export default __webpack_public_path__ + "static/media/sun.77bac176.svg";